// CIS-prioritized timezones
export const TIMEZONES = [
  'Europe/Moscow', 'Europe/Kaliningrad', 'Europe/Samara',
  'Asia/Yekaterinburg', 'Asia/Omsk', 'Asia/Novosibirsk', 'Asia/Krasnoyarsk',
  'Asia/Irkutsk', 'Asia/Yakutsk', 'Asia/Vladivostok', 'Asia/Magadan', 'Asia/Kamchatka',
  'Asia/Almaty', 'Asia/Tashkent', 'Asia/Bishkek', 'Asia/Dushanbe',
  'Europe/Minsk', 'Europe/Kiev', 'Asia/Tbilisi', 'Asia/Yerevan', 'Asia/Baku',
  'Europe/London', 'Europe/Berlin', 'Europe/Paris',
  'America/New_York', 'America/Los_Angeles',
  'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Dubai', 'UTC',
];

export function detectTimezone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone; }
  catch { return 'Europe/Moscow'; }
}

export function formatPhoneRU(value) {
  // Normalize to +7 (XXX) XXX-XX-XX
  const digits = (value || '').replace(/\D/g, '');
  let d = digits;
  if (d.startsWith('8')) d = '7' + d.slice(1);
  if (!d.startsWith('7')) d = '7' + d;
  d = d.slice(0, 11);
  const part1 = d.slice(1, 4);
  const part2 = d.slice(4, 7);
  const part3 = d.slice(7, 9);
  const part4 = d.slice(9, 11);
  let out = '+7';
  if (part1) out += ` (${part1}`;
  if (part1.length === 3) out += ')';
  if (part2) out += ` ${part2}`;
  if (part3) out += `-${part3}`;
  if (part4) out += `-${part4}`;
  return out;
}
